import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService } from 'primeng/api';
import { NotificationTypes } from 'src/app/app.enums';
import { AuthService } from 'src/app/Services/auth.service';
import { InstagramService } from 'src/app/Services/instagram.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-delete-instagram-meta-data',
    templateUrl: './delete-instagram-meta-data.component.html',
    styleUrls: ['./delete-instagram-meta-data.component.css'],
    standalone: false
})
export class DeleteInstagramMetaDataComponent implements OnInit{
  public isAuthenticated: boolean = false;
  public firstName!: string;
  public username!: string;
  public userId!: string;
  public logoImgUrl!: string;
  public password: string = '';
  public Id: string | null = null;
  public platform: string = '';
  public isInstagramAccountDeleteConfirmationDailogVisible: boolean = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private notificationsService: NotificationsService,
    private ngxSpinnerService: NgxSpinnerService,
    private confirmationService: ConfirmationService,
    private instagramService: InstagramService,
    private transloco: TranslocoService){

  }

  public ngOnInit(): void {
    this.isAuthenticated = this.authService.isAuthenticated();
    if (this.isAuthenticated) {
        const currentUser = this.authService.getCurrentUser();
        if (currentUser) {
            this.firstName = currentUser.FirstName.split(' ')[0];
            this.username = currentUser.EmailAddress;
            this.logoImgUrl = currentUser.LogoUrl;
            this.userId = currentUser.UserId;
        }
    }
  }

  public deleteInstagramMetaData(): void {
    this.isInstagramAccountDeleteConfirmationDailogVisible = true
  }
  
  public onCloseInstagramMetadataConfirmationDailog(){
    this.isInstagramAccountDeleteConfirmationDailogVisible = false
  }
  
  public deleteInstagramAccounts(){
    if (this.isFormValid()) {
        // this.confirmationService.confirm({
        //   message: 'Are you sure you want to delete your account?',
        //   header: 'Confirmation',
        //   icon: 'pi pi-exclamation-triangle',
        //   accept: () => {
            this.ngxSpinnerService.show();
            this.instagramService.deleteAllInstagramMetaData(this.username, this.password).subscribe(
                (response) => {
                  this.ngxSpinnerService.hide();
                  if (response.Success) {
                      this.notificationsService.showNotification(this.transloco.translate('deleteInstagramMetaData.success'),response.ResponseMessage,NotificationTypes.Success);
                      this.router.navigate(['/']);
                  } else {
                      this.notificationsService.showNotification(this.transloco.translate('deleteInstagramMetaData.error'),response.ResponseMessage,NotificationTypes.Error);
                  }
                },
                (error) => {
                  console.error('Error deleting account:', error);
                  this.ngxSpinnerService.hide();
                  this.notificationsService.showNotification(this.transloco.translate('deleteInstagramMetaData.error'),this.transloco.translate('deleteInstagramMetaData.errorDeletingAccount'),NotificationTypes.Error);
                }
                );
          // }
          // });
    } else {
        this.notificationsService.showNotification(this.transloco.translate('deleteInstagramMetaData.error'),this.transloco.translate('deleteInstagramMetaData.incorrectUsernamePassword'),NotificationTypes.Error);
    }
  }

  public isFormValid(): boolean {
    return !!this.username && this.password.length > 0;
  }

}
